// @core/api/endpoints/webhook/create_webhook_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateWebhookPolicyRequest,
  WebhookPolicyResponse,
} from '../../../types/webhook';

const BASE_PATH = '/webhook';

/**
 * Create webhook policy
 * Creates a webhook policy for a scope entity (organization, team, department). Configures endpoint limits, rate limiting, delivery defaults, and security requirements.
 */
export async function CreateWebhookPolicy(
  data: CreateWebhookPolicyRequest,
  options?: RequestOptions
): Promise<WebhookPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/webhook-policies`;
  const requestOptions = options;
  return client.post<WebhookPolicyResponse>(requestPath, data, requestOptions);
}
